import React, {useState, useCallback} from 'react';
import {getFacebookPreviewForEntity, getDataForFacebookAutocomplete} from 'utils/api';
import {toast} from 'react-toastify';
import {Input, Button} from 'reactstrap';
import SpinnerButton from 'components/SpinnerButton';

const AddFacebookSortInput = ({activeEntityId, addSourceToEntity}) => {
    const [fetchingContent, setFetchingContent] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(false);
    const [autocompleteData, setAutocompleteData] = useState(null);
    const [autocompleteId, setAutocompleteId] = useState(null);

    const fetchFacebookContent = async(value) => {
        try {
            setFetchingContent(true);
            const params = {
                url: value ? value : (inputValue ? inputValue.trim() : ''),
                entityId: parseInt(activeEntityId),
            };
            let data = await getFacebookPreviewForEntity(params);
            addSourceToEntity(data.content, 'facebook');
            setIsAutocompleteOpen(false);
            handleInputChange('');
            toast.info('Source successfully added');
            setFetchingContent(false);
        } catch(e) {
            setFetchingContent(false);
            setIsAutocompleteOpen(false);
            if(e.message.length < 150) {
                toast.error(e.message);
                throw e.message;
            }
        }
    };

    const handleSearchChange = (e) => {
        if(e.key === 'Enter') {
            if(e.target.value && e.target.value.trim()) {
                fetchFacebookContent();
            }
        } else {
            handleInputChange(e.target.value);
        }
    };

    function debounce(func, wait) {
        let timeout;
        return function(...args) {
            const context = this;
            if(timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                timeout = null;
                func.apply(context, args);
            }, wait);
        };
    }

    const getAutocomplete = (val, userId) => {
        const params = {
            title: val,
        };
        getDataForFacebookAutocomplete(params)
            .then(data => {
                setAutocompleteData(data.content);
                setIsAutocompleteOpen(true);
            })
            .catch((err) => {
                console.log('error: ', err.message);
                //toast.error(error.message);
            });
    };

    const debouncedAutocomplete = useCallback(debounce(getAutocomplete, 500), []);

    const handleInputChange = (value, isAutocomplete) => {
        setInputValue(value);
        let isIncludeUrl = value.trim().includes('https://facebook.com') || value.trim().includes('https://www.facebook.com');
        if(!isAutocomplete && !isIncludeUrl && value.trim() !== '') {
            debouncedAutocomplete(value);
        } else {
            setIsAutocompleteOpen(false);
        }
        if(autocompleteId) {
            setAutocompleteId(null);
        }
    };

    const changeInputToAutocomplete = (value, id) => {
        handleInputChange(value, true);
        setIsAutocompleteOpen(false);
        setAutocompleteId(id);
        fetchFacebookContent(value);
        //document.getElementById('facebook-input').focus();
    };

    return (
        <div className="w-100">
            <div className="d-flex">
                <div className="w-100 d-flex">
                    <div className="d-flex justify-content-between w-100">
                        <div className="position-relative w-100">
                            <i className="fab fa-facebook add-entity-source-input-icon" style={{color: '#4267B2'}}/>
                            <Input
                                onKeyPress={(e) => handleSearchChange(e)}
                                onChange={(e) => handleSearchChange(e)}
                                value={inputValue}
                                placeholder="Enter the Facebook public page URL"
                                type="text"
                                className="create-fetch_input"
                                style={{padding: '0 35px'}}
                                autoComplete="off"
                            />
                            {inputValue && inputValue.trim() && (
                                <i
                                    onClick={() => handleInputChange('')}
                                    className="fa fa-times-circle"
                                    style={{
                                        position: 'absolute',
                                        cursor: 'pointer',
                                        right: '0',
                                        top: '0',
                                        padding: '10.5px',
                                    }}
                                />
                            )}
                        </div>
                        {/*<Button*/}
                        {/*    className="calltoaction-button"*/}
                        {/*    style={{marginLeft: '10px', lineHeight: '0', minWidth: '75px'}}*/}
                        {/*    onClick={() => fetchFacebookContent()}*/}
                        {/*    disabled={!inputValue.trim() || fetchingContent}*/}
                        {/*>*/}
                        {/*    {fetchingContent ?*/}
                        {/*        <div className="flex-centered">*/}
                        {/*            <i className="fa fa-spinner fa-spin"/>*/}
                        {/*        </div>*/}
                        {/*        :*/}
                        {/*        <React.Fragment>*/}
                        {/*            <span style={{fontSize: '14px '}}><i style={{display: 'inline'}} className="fas fa-plus"/></span>&nbsp;*/}
                        {/*            <span style={{fontSize: '16px'}}>Add</span>*/}
                        {/*        </React.Fragment>*/}
                        {/*    }*/}
                        {/*</Button>*/}
                        <div style={{marginLeft: '10px'}}>
                            <SpinnerButton
                                minWidth="75px"
                                title="Add"
                                iconClass="fas fa-plus"
                                submitting={fetchingContent}
                                onClick={fetchFacebookContent}
                            />
                        </div>
                    </div>


                </div>
            </div>
            <div
                className="companies_fb-autocomplete-container"
                style={(isAutocompleteOpen && (inputValue && inputValue.trim().length > 0)) ? {
                    border: '1px solid #e4e7ea',
                    height: `${autocompleteData.length * 53}px`,
                } : {height: '0'}}
            >
                {isAutocompleteOpen && autocompleteData && autocompleteData.length > 0 && (inputValue && inputValue.trim().length > 0) &&
                autocompleteData.map(item =>
                    <div key={item.id} onClick={() => changeInputToAutocomplete(item.link, item.id)}
                         className="facebook-autocomplete-item">
                        <div style={{fontWeight: '800'}}>{item.name}</div>
                        <div>{item.link}</div>
                    </div>,
                )}
            </div>
        </div>
    );
};

export default AddFacebookSortInput;